// This is a newer version of the former carousel progress dots component.
// This version removes the absolute position style and opts for a div that is part of the carousel containers flexbox.
import React from 'react';
import { Box } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';

interface ProgressDotsProps {
  length: number;
  currentDot: number;
}

const ProgressDot = ({
  isActive,
  label,
}: {
  isActive: boolean;
  label: string;
}) => (
  <Box
    as="li"
    css={{
      display: 'flex',
      height: '$threeQuarters',
      width: '$threeQuarters',
      cursor: 'default',
      backgroundColor: isActive
        ? '$interactiveActionPrimary'
        : '$interactiveActionDisabled',
      borderRadius: '$circle',
    }}
    data-testid="progress-dot"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...(isActive && { 'aria-current': 'step', 'aria-label': label })}
  />
);

export const ProgressDots = ({ length, currentDot }: ProgressDotsProps) => {
  const { formatMessage } = useIntl();
  const progressDots = new Array(length).fill(true);

  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'row',
        justify: 'center',
        align: 'center',
        width: '100%',
        gap: '$half',
        '@mobile': { flexWrap: 'wrap' },
        justifyContent: 'center',
      }}
      as="ul"
    >
      {progressDots.map((active, index) => {
        const key = `progress-dot-${index}-${active}`;
        const isActive = currentDot === index;
        return (
          <ProgressDot
            isActive={isActive}
            key={key}
            label={formatMessage(
              { id: 'SLIDE_OF_TOTAL' },
              { key: index + 1, total: length },
            )}
          />
        );
      })}
    </Box>
  );
};
